export default __webpack_public_path__ + "static/media/case-study-4-lorawan-asset-tracking.738db90f.mp4";